import { ReactNode } from 'react';
import { Global, MantineProvider } from '@mantine/core';

import { global, theme } from 'theme';
import { useTranslation } from 'react-i18next';

type Props = {
  children: ReactNode;
};

export const StylesProvider = ({ children }: Props) => {
  const { i18n } = useTranslation();

  return (
    <MantineProvider
      theme={{ ...theme, datesLocale: i18n.language }}
      withGlobalStyles
      withNormalizeCSS
    >
      <Global styles={global} />
      {children}
    </MantineProvider>
  );
};
